// copiato da src/lib/solitario/useTutorialVisto.ts:1-37 @ cad51507af021388ceb3a5de34eb61259665077d, generalizzato: la chiave non e` scritta qui, la passa il gioco.
import { useCallback, useState } from 'react';

import { storage, StorageKey, type ChiaveTutorialVisto } from '@/lib/storage';

/** Una chiave dichiarata in `lib/storage.ts`: una delle sue (`StorageKey`) o quella che rende `chiaveTutorialVisto(gioco)`. Mai una stringa qualunque. */
export type ChiaveVisto = (typeof StorageKey)[keyof typeof StorageKey] | ChiaveTutorialVisto;

/**
 * Il «GIA` VISTO» del tutorial di un gioco: UNA chiave sul dispositivo, quella che il gioco passa, mai il server.
 * ⛔ E` l'UNICO file della zona che usa `storage` di `lib/storage.ts`, e non nomina nessuna chiave: `tools/verify-tutorial.ts` lo guarda.
 *
 * VISTO = APERTO UNA VOLTA (qualunque uscita): si segna all'apertura. ⚠️ «Non lo so» non e` «non visto» (la regola del burraco, `lib/burraco/impostazioni.ts`): uno storage che manca o LANCIA
 * vale VISTO, niente pallino. Ma `storage.get` rende `null` sia per «la chiave non c'e`» sia per «lo storage lancia» (il wrapper non lancia mai): per distinguerli la prima lettura SCRIVE `'0'`
 * (= non ancora aperto) e la rilegge; se non la ritrova lo storage non c'e`, quindi visto. `'1'` = aperto; `'0'` = non ancora; qualunque altro valore e` «non lo so» = visto.
 */
const NON_ANCORA = '0';
const VISTO = '1';

export function leggiVisto(chiave: ChiaveVisto): boolean {
  const v = storage.get(chiave);
  if (v === VISTO) return true;
  if (v === NON_ANCORA) return false;
  if (v !== null) return true;
  storage.set(chiave, NON_ANCORA);
  return storage.get(chiave) !== NON_ANCORA;
}

export function useTutorialVisto(chiave: ChiaveVisto): { visto: boolean; segnaVisto: () => void } {
  const [visto, setVisto] = useState(() => leggiVisto(chiave));
  const segnaVisto = useCallback(() => {
    storage.set(chiave, VISTO);
    setVisto(true);
  }, [chiave]);
  return { visto, segnaVisto };
}
